import Link from '@mui/material/Link'
import Typography, { TypographyProps } from '@mui/material/Typography'
import React from 'react'
import { Link as RouterLink } from 'react-router-dom-v5-compat'

import { formatCampaign } from '@/app/service/util/format'

import Tooltip from './tooltip'

type Props = {
  align?: TypographyProps['align']
  campaignId?: number
  campaignName?: string
  size?: 'medium' | 'small'
}

const CampaignLink: React.FC<Props> = ({ align, campaignId, campaignName, size = 'medium' }) => {
  const variant = size === 'small' ? 'body2' : 'body1'
  const hasCampaign = Number.isInteger(campaignId) && Number(campaignId) > 0

  if (!hasCampaign) {
    return (
      <Typography align={align} color="text.disabled" fontStyle="italic" variant={variant}>
        No campaign
      </Typography>
    )
  }

  const campaign = formatCampaign({ campaignId, campaignName })

  return (
    <Tooltip title={campaign}>
      <Link
        align={align}
        component={RouterLink}
        sx={{ display: 'block', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
        to={`/campaigns/${campaignId}`}
        underline="hover"
        variant={variant}
      >
        {campaign}
      </Link>
    </Tooltip>
  )
}

export default CampaignLink
